import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/banners";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + banners.length) % banners.length);
  };

  return (
    <section className="relative w-full h-[460px] md:h-[600px] overflow-hidden">
      {banners.map((banner, i) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={banner.image}
            alt={banner.title}
            title={`${banner.title} - 香蕉社区精选话题`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/45 to-foreground-950/30" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-4 md:px-8 pt-16">
        <div key={index} className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/90 text-foreground-950 text-xs font-medium mb-5">
            <i className="ri-fire-fill" />
            {banners[index].tag}
          </span>
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 leading-tight text-balance">
            {banners[index].title}
          </h1>
          <p className="mt-4 text-sm md:text-lg text-background-100/90 max-w-xl mx-auto">
            {banners[index].subtitle}
          </p>
          <div className="mt-8 flex items-center justify-center gap-3 flex-col sm:flex-row">
            <Link
              to={`/topic/${banners[index].topicId}`}
              className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-primary-500 hover:bg-primary-600 text-foreground-950 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看精选话题
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/post"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-background-50/15 hover:bg-background-50/25 border border-background-50/40 text-background-50 font-medium backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-add-line" />
              我也来发布
            </Link>
          </div>
        </div>

        {/* Controls */}
        <div className="absolute bottom-6 md:bottom-8 left-0 right-0 flex items-center justify-center gap-4">
          <button
            type="button"
            onClick={() => go(-1)}
            aria-label="上一张"
            className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/35 border border-background-50/40 text-background-50 flex items-center justify-center backdrop-blur-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <div className="flex items-center gap-2">
            {banners.map((b, i) => (
              <button
                key={b.id}
                type="button"
                aria-label={`切换到第 ${i + 1} 张`}
                onClick={() => setIndex(i)}
                className={`h-2 rounded-full transition-all cursor-pointer ${
                  i === index ? "w-7 bg-primary-500" : "w-2 bg-background-50/50 hover:bg-background-50/80"
                }`}
              />
            ))}
          </div>
          <button
            type="button"
            onClick={() => go(1)}
            aria-label="下一张"
            className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-background-50/20 hover:bg-background-50/35 border border-background-50/40 text-background-50 flex items-center justify-center backdrop-blur-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>
      </div>
    </section>
  );
}